<template>
  <a-table
    class="tableChild"
    bordered
    :columns="tableData.columns"
    :data-source="tableData.data"
    :pagination="false"
    :rowKey="record => record.id"
    :scroll="{ x: 1200 }"
  >
    <template slot="actions" slot-scope="text, record">
      <a href="javascript:;" @click.stop="() => handleDetail(record)">详情</a>
    </template>
  </a-table>
</template>
<script>
export default {
  data () {
    return {
      tableData: {
        columns: [
          {
            title: '设备名称',
            dataIndex: 'name',
            align: 'left',
            width: 400
          },
          {
            title: '设备编号',
            dataIndex: 'equipmentNumber',
            align: 'left',
            width: 200
          },
          {
            title: '重要型分类',
            dataIndex: 'importanceType',
            align: 'left',
            width: 100
          },
          {
            title: '规格型号',
            dataIndex: 'specification',
            align: 'left',
            width: 250
          },
          {
            title: '供应商',
            dataIndex: 'supplier',
            align: 'left'
            // width: 200
          }
        ],
        data: [],
        pagination: {
          pageNum: 1,
          pageSize: 10,
          total: 0,
          pageSizeOptions: ['10', '20', '30', '40'],
          showSizeChanger: true,
          showQuickJumper: true
        }
      },
      analogData: []
    }
  },
  props: {
    model: Object
  },
  watch: {
    model: {
      handler (model) {
        if (model) {
          this.tableData.data = model
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 详情跳转
    handleDetail () {
    //   this.$router.push({})
    },
    // 切换页码
    handleTableChange () {

    }
  }
}
</script>

<style lang="less" scoped>
.table {
  margin-left: -1px;
  margin-right: -1px;
  // /deep/.ant-table-pagination.ant-pagination {
  //   margin-bottom: 10px !important;
  //   margin-right: 10px !important;
  // }

  /deep/.ant-table-thead > tr > th {
    background: rgba(8, 64, 159, 0.1);
  }
  /deep/.ant-table-tbody > tr > td {
    padding: 10px;
  }
}
</style>
